import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addProcessRemark = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/addprocessremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmStopSim = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/confirmstopsim/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const reopeningSim = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/reopeningsim/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getExcelReport = (params, urlParams) => {
  return axios.request({
    url: '/da/stopsimcarddata/getexcelreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}
